import { Button } from "@mui/material";
import { styled } from "@mui/system";
const Bubbles = styled("div")`
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-top: 8px;
  margin-bottom: ${({ theme }) => theme.spacing(2.5)};
  gap: 8px;
`;
const BubbleDetails = styled("span")`
  display: flex;
  flex-direction: column;
`;
const Bubble = styled(Button)`
  display: flex;
  align-items: center;
  padding: 4px 18px 4px 8px;
`;
export {
  Bubble,
  BubbleDetails,
  Bubbles
};
